import React from 'react'
import {
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  Grid,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import _ from 'lodash'


const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  dialogStatement: {
    fontSize: 16,
    fontWeight: 300,
  },
  dialogContentRoot: {
    overflow: 'unset',
  }
}))

export default function ManageCommentDrawer(props) {
  const classes = useStyles()
  const { questionId, closeDialog, questionData } = props

  return (
    !!questionId ?
    <>
      <Drawer
        anchor="right"
        open={ questionId }
        onClose={ closeDialog }
      >
        <Grid style={{ maxWidth: 700, height: '95%', display: 'flex', flexDirection: 'column', overFlow: 'overlay' }}>
          <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
            <strong>Usuário</strong>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }}>
            <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
              { _.get(props, 'questionData.userName') }
            </DialogContentText>
          </DialogContent>

          <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
            <strong>Pergunta</strong>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }}>
            <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
              { _.get(props, 'questionData.hierarchy') }
              { ' - ' }
              { _.get(props, 'questionData.drawerContent.dimensionAbbreviation') }
              { ' ' }
              { _.get(props, 'questionData.drawerContent.hierarchy') }
              { ' - ' }
              { _.get(props, 'questionData.drawerContent.statement') }
            </DialogContentText>
          </DialogContent>

          <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
            <strong>Comentário</strong>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }}>
            <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
              { _.get(props, 'questionData.contentDrawer') }
              { ' - ' }
              { _.get(props, 'questionData.createdAt') }
            </DialogContentText>
          </DialogContent>

          <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
            <strong>Dimensão ISE</strong>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }}>
            <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
              { questionData.dimension }
            </DialogContentText>
          </DialogContent>

          <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
            <strong>Indicador</strong>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }}>
            <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
              { questionData.indicator }
            </DialogContentText>
          </DialogContent>


          <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
            <strong>Dimensão</strong>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }}>
            <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
              { questionData.topic }
            </DialogContentText>
          </DialogContent>

          <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
            <strong>Subtópicos</strong>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }} style={{ marginBottom: 85 }}>
            <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
              { questionData.subtopic }
            </DialogContentText>
          </DialogContent>
        </Grid>
      </Drawer>
    </> : <> </>
  )
}
